module.exports = __webpack_public_path__ + "static/media/Third-FlagSmall.ebc6a889.gif";